import React, { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { IConfigComponent } from '@ts/ui-models';
import { generateGlobalColumns, generateBasicColumn } from '@ts/storybook';
import { IWarningRule } from '@ts/ui-models';
interface IReadingTypesProps {
  title?: string;
  configComponent?: IConfigComponent;
  fetchURL?: string;
  inheritedProps?: any;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'readingTypes',
  aclId: 'tsReadingType',
  entity: 'readingType',
  fetchURL: '/api/readingTypes',
  crudURL: '/api/readingType',
};

const ReadingTypes = (props: IReadingTypesProps) => {
  const { configComponent = defaultConfigComponent } = props;
  configComponent.fetchURL = props.fetchURL || configComponent.fetchURL;

  const getColumns = useMemo((): GridColDef<IWarningRule>[] => {
    const mixProps = { ...props, configComponent };
    const globalCells = generateGlobalColumns(mixProps);
    return [
      globalCells.id(),
      globalCells.name(),
      generateBasicColumn({ field: 'unitName', headerName: 'Unit' }, { field: 'unit.name' }),
      generateBasicColumn({ field: 'quantity', headerName: 'Quantity' }, { field: 'unit.quantity.name' }),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      title={props.title}
      configComponent={configComponent}
      columns={getColumns}
      //Extra data
      inheritedProps={props.inheritedProps}
    />
  );
};

export default ReadingTypes;
